import React from "react";
import "./DiscoverArtistsSection.css";

const DiscoverArtistsSection = () => {
    return <div className="discover-artists-section"></div>;
};

export default DiscoverArtistsSection;
